import api from "../lib/apiClient";
export const getDailyLesson = () => api.get("/lessons/daily").then((r) => r.data);
